import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import RoboticsShell from "./RoboticsShell";
import { useAuth } from "../../lib/auth";

/**
 * Sign-up — Robotics-branded, wired to the shared STEAM auth backend
 * (invisible to the student).
 */
export default function RoboticsSignup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  function update(k, v) { setForm((f) => ({ ...f, [k]: v })); }

  async function onSubmit(e) {
    e.preventDefault();
    if (!form.email || !form.password || !form.name) {
      setStatus({ state: "err", msg: "Name, email and password are required." });
      return;
    }
    if (form.password.length < 8) {
      setStatus({ state: "err", msg: "Password must be at least 8 characters." });
      return;
    }
    setStatus({ state: "loading", msg: "" });
    try {
      await register(form);
      nav("/robotics/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail || "Sign-up failed. Try a different email.";
      setStatus({ state: "err", msg: String(detail) });
    }
  }

  return (
    <RoboticsShell>
      <section className="rbx-page" data-testid="rbx-page-signup" style={{ maxWidth: 480 }}>
        <span className="rbx-eyebrow">Session · Create account</span>
        <h1 className="rbx-page__title" data-testid="rbx-signup-title">
          Get your own bench.
        </h1>
        <p className="rbx-page__lede">
          Free while we&rsquo;re in preview. Already have an account?{" "}
          <Link to="/robotics/signin" style={{ color: "var(--rbx-gold)" }}>Sign in</Link>.
        </p>

        <form className="rbx-form" onSubmit={onSubmit} data-testid="rbx-signup-form">
          <div>
            <label className="rbx-label" htmlFor="rbx-signup-name">Full name</label>
            <input id="rbx-signup-name" className="rbx-input" value={form.name}
                   onChange={(e) => update("name", e.target.value)} data-testid="rbx-signup-name"
                   autoComplete="name"/>
          </div>
          <div>
            <label className="rbx-label" htmlFor="rbx-signup-email">Email</label>
            <input id="rbx-signup-email" className="rbx-input" type="email" value={form.email}
                   onChange={(e) => update("email", e.target.value)} data-testid="rbx-signup-email"
                   autoComplete="email"/>
          </div>
          <div>
            <label className="rbx-label" htmlFor="rbx-signup-password">Password</label>
            <input id="rbx-signup-password" className="rbx-input" type="password" value={form.password}
                   onChange={(e) => update("password", e.target.value)} data-testid="rbx-signup-password"
                   autoComplete="new-password"
                   placeholder="Minimum 8 characters"/>
          </div>
          <div>
            <button type="submit" className="rbx-btn rbx-btn--primary"
                    disabled={status.state === "loading"} data-testid="rbx-signup-submit">
              {status.state === "loading" ? "Creating…" : "Create account"}
            </button>
          </div>
          {status.msg ? (
            <p className={`rbx-form__msg ${status.state === "ok" ? "rbx-form__msg--ok" : "rbx-form__msg--err"}`}
               data-testid="rbx-signup-msg">
              {status.msg}
            </p>
          ) : null}
        </form>
      </section>
    </RoboticsShell>
  );
}
